/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const FronteggUserCredentials = core.serialization.object({
    email: core.serialization.string(),
    name: core.serialization.string().optional(),
    tenantId: core.serialization.string().optional(),
});
